
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiPointer as ObcPoiPointerElement} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi-pointer/poi-pointer.js';
 
 
 

 
 export const ObcPoiPointer = createComponent({
   react: React,
   tagName: 'obc-poi-pointer',
   elementClass: ObcPoiPointerElement,
   events: {
     
   }
  });
 
 